import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskWorkflowConfigRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-workflow-scheme-config',
	path: '/jira/servicedesk/projects/:projectKey/settings/workflows',
	exact: true,
};
